(function ($) {
  var singleVideoV1 = {
    formatter: $('.single-video-v1')
  };

  Drupal.behaviors.singleVideoV1 = {
    get: function (key) {
      return singleVideoV1[key];
    },

    set: function (key, val) {
      singleVideoV1[key] = val;
    },

    attach: function (context) {
      var self = this;
      var formatter = self.get('formatter');
      var animationTime = 1000;

      formatter.each(function () {
        var thisFormatter = $(this);
        var link = thisFormatter.find('.button').attr('href');
        var $placeholder = $('.js-image-placeholder', thisFormatter);
        var $soundControl = $('.js-single-video-sound-control', thisFormatter);
        var $revealBlock = $('.js-single-video-reveal', thisFormatter);

        if (typeof link !== 'undefined') {
          thisFormatter.wrapInner('<a href="' + link + '"></a>');
        }
        thisFormatter.find('.image-placeholder.has-video').on('click', function() {
          var $this = $(this);
          var autoplay = $this.hasClass('js-enable-autoplay') ? true : false;
          // swap
          var placeholderHeight = $this.find('img').height();
          var videoContainer = thisFormatter.find('.video-wrapper');
          var playController = $();
          // autoplay
          var iframeTag = videoContainer.find('iframe');
          var videoTag = videoContainer.find('video');

          if (iframeTag.length > 0) {
            videoContainer.fadeIn(animationTime);
            // autoplay
            iframeTag.css('height', placeholderHeight);
            var iframeSrc = iframeTag.attr('src');
            var autoplaySrc = iframeSrc;

            if (autoplay) {
              autoplaySrc = iframeSrc + '&autoplay=1';
            }
            iframeTag.attr('src', autoplaySrc);
          }

          if (videoTag.length > 0) {
            $soundControl.off('click.video').on('click.video', function () {
              $soundControl.toggleClass('sound-icon--mute');
              videoTag.prop('muted', $soundControl.hasClass('sound-icon--mute'));
            });
            // set player height
            videoTag.css('height', placeholderHeight);
            // autoplay
            playController = videoContainer.find('.video_player_controls .play');
            // The video container doesn't listen to click event if the controllers
            // are available
            if (playController.length) {
              playController.trigger('click');
            } else {
              videoTag.trigger('click');
            }
            if (autoplay) {
              videoTag.prop('muted', true);
            }
            videoTag.closest('.video_player').once('js-video-player-start').on('play', function () {
              if ($revealBlock.length) {
                thisFormatter.css({ 'background-image': '' });
                $placeholder.find('img').css({ 'visibility': 'hidden' });
              }
              if ($soundControl.length) {
                $soundControl.toggleClass('sound-icon--mute', videoTag.prop('muted'));
              }
              videoContainer.fadeIn(animationTime);
            });
            // swap back when video ends
            videoTag.closest('.video_player').once('js-video-player-end').on('ended', function () {
              videoContainer.fadeOut(animationTime);
              if ($revealBlock.length) {
                $this.hide();
                $revealBlock.fadeIn(animationTime);
                if ($revealBlock.data('replay-button')) {
                  var $button = $($revealBlock.data('replay-button') + ' .js-elc-button', $revealBlock);

                  $button.off('click.replayVideo').on('click.replayVideo', function (event) {
                    $this.show();
                    $revealBlock.hide();
                    videoContainer.fadeIn(animationTime);
                    event.preventDefault();
                    videoTag.currentTime = '0';
                    videoTag.trigger('play');
                  });
                }
              }
            });
          }
        });
        thisFormatter.find('.image-placeholder.has-video.js-enable-autoplay').each(function () {
          var $thisWrapper = $(this);
          var autoplayAfter = $thisWrapper.data('autoplayAfter') || animationTime;

          setTimeout(function () {
            $thisWrapper.trigger('click');
          }, autoplayAfter);
        });
      });
    }
  };
})(jQuery);
